angular.module('bmsApp.merrymaids.schedule')
	.controller('MMScheduleCalendarCtrl', MMScheduleCalendarCtrl);

MMScheduleCalendarCtrl.$inject = [
	'$compile',
	'$scope',
	'notify',
	'uiCalendarConfig',
	'MMScheduleSvc',
	'MMScheduleDataSvc',
	'MMScheduleCalendarDataSvc',
	'$localStorage',
];

function MMScheduleCalendarCtrl(
	$compile,
	$scope,
	notify,
	uiCalendarConfig,
	MMScheduleSvc,
	MMScheduleDataSvc,
	MMScheduleCalendarDataSvc,
	$localStorage
) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		handlers: handlers,
		events: [],
		calendar: {
			config: {},
			loading: true,
			handlers: {},
		},
		dayInfo: {
			date: null,
			loading: false,
			unassignedEmployees: {},
			unassignedJobParts: {},
			routes: {},
		},
	});

	// Calendar --------------------------------------------------------------------------------------------------------
	self.calendar.handlers.eventRender = (event, element, view) => {
		element.find('.fc-title').html(event.title);
		$compile(element)($scope);
	}

	self.calendar.handlers.eventClick = (event, jsEvent, view) => {
		loadDayInfo(event.start);
	}

	self.calendar.handlers.loading = (isLoading, view) => {
		self.calendar.loading = isLoading;
	}

	self.calendar.config = {
		firstDay: 1,
		events: {
			url: 'api/merrymaids/schedule/calendar/days',
			headers: { FranchiseInstanceId: $localStorage.currentInstance.id },
			cache: false,
		},
		eventSources: [{}],
		eventRender: self.calendar.handlers.eventRender,
		eventClick: self.calendar.handlers.eventClick,
		loading: self.calendar.handlers.loading,
		header: {
			left: 'prev,next today',
			center: 'title',
			right: '',
		},
	};

	// Methods ---------------------------------------------------------------------------------------------------------
	function loadDayInfo(date) {
		self.dayInfo.date = date;
		self.dayInfo.loading = true;
		return MMScheduleCalendarDataSvc.dayInfo({
			date: self.dayInfo.date.format(),
		}).then((response) => {
			angular.extend(self.dayInfo, response.data);
			self.dayInfo.loading = false;
		});
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	self.handlers.viewWarningsClick = () => {
		MMScheduleSvc.warningsModal(self.dayInfo.warnings, self.dayInfo.date, false);
	};

	self.handlers.viewWorksheetsClick = () => {
		MMScheduleSvc.worksheetsModal(self.dayInfo.date.format(), self.dayInfo.routes, self.dayInfo.unassignedJobParts);
	};

	self.handlers.preInvoiceClick = () => {
		MMScheduleSvc.preInvoiceModal(self.dayInfo.date);
	};

	self.handlers.confirm = () => {
		return MMScheduleDataSvc.confirmDay({date: self.dayInfo.date.format()}).then((results) => {
			if (results.data.error) {
				// self.loading = false;
				notify({
					message: 'Unable to auto schedule this date because ' + results.data.error,
					duration: '0',
					classes: 'error'
				});
			} else {
				uiCalendarConfig.calendars.calendar.fullCalendar('refetchEvents');
				loadDayInfo(self.dayInfo.date).then(() => {
					if (self.dayInfo.warnings.warningCount > 0) {
						MMScheduleSvc.warningsModal(self.dayInfo.warnings, self.dayInfo.date, true);
					}
				});
			}
		});
	};
}
